import React, { useEffect, useMemo, useState } from "react";
import Container from "../components/Layout/Container";
import ContentBlock from "../components/Layout/ContentBlock";
import FilterMenu from "../components/Layout/FilterMenu";
import TableUi from "../components/Layout/TableUI";
import TableFilterBox from "../components/common/TableFilterBox";
import ContentValidation from "../components/common/ContentValidation";
import {
  Label,
  Pagination,
  RangePicker,
  SelectInput,
  TextInput,
} from "../components/globals";
import { DEFAULT_PER_PAGE } from "../helpers/default";
import { ButtonDelete, ButtonSmall } from "../components/common/Buttons";
import { Checkbox, Dropdown, Select, Tooltip } from "antd";
import ClientInfoComponent from "../components/Repetitive_components/clientInfoComponent";
import TableComment from "../components/orders/accepted_orders/items/TableComment";
import BalancesIndex from "../components/orders/accepted_orders/items/balancesIndex";
import {
  antdMessageError,
  antdMessageSuccess,
  exportDocument,
  formatDatePlus,
  getDateFormat,
  returnEuroString,
} from "../helpers/Utils";
import { AiOutlineCheck } from "react-icons/ai";
import { IconLostCart } from "../components/Layout/Icons";
import { handleKeyDown2 } from "../helpers/FunctionsGlobal";
import moment from "moment";
import AntdConfirm from "../helpers/AntdConfirm";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useMutation,
} from "react-query";
import ModalLostCart from "../components/lost_cart/ModalLostCart";
import Axios from "axios";
import { getCommentStateOption } from "../redux/Actions/comment_StateAction";
import { useDispatch, useSelector } from "react-redux";
import { setOrderShopsOptions } from "../redux/Actions/options_action";
import useChecked from "../hooks/useChecked";
const { Option, OptGroup } = Select;

const initialFilters = {
  cart_id_eq: null,
  order_shop_id_in: "",
  lost_at: ["", ""],
  customer_firstname_or_customer_lastname_or_customer_email_or_customer_company_code_cont_any:
    null,
  order_rows_product_name_or_order_rows_product_reference_or_order_rows_product_upc_cont:
    null,
  lost_cart_comments_body_or_lost_cart_comments_user_title_cont: null,
};

const defaultFilters = [
  {
    label: "Cart ID",
    value: "cart_id_eq",
  },
  {
    label: "Order store",
    value: "order_shop_id_in",
  },
  {
    type: "date",
    label: "Lost date",
    value: "lost_at",
  },
  {
    label: "Client",
    value:
      "customer_firstname_or_customer_lastname_or_customer_email_or_customer_company_code_cont_any",
  },
  {
    label: "Goods",
    value:
      "order_rows_product_name_or_order_rows_product_reference_or_order_rows_product_upc_cont",
  },
  {
    label: "Comment statuses",
    value: "comment_states",
  },
  {
    label: "Comment",
    value: "lost_cart_comments_body_or_lost_cart_comments_user_title_cont",
  },
];

export const queryLostCartsClient = new QueryClient();

const fetchLostCarts = async ({ queryKey }) => {
  const [key, { page, perPage, filterStr }] = queryKey;
  const response = await Axios.get(
    `/api/v1/${key}?page=${page}&per_page=${perPage}${filterStr}`
  );
  return response.data;
};
function LostCartScreen({ match }) {
  const { order_shops } = useSelector((state) => state.options);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(DEFAULT_PER_PAGE);
  const [filters, setFilters] = useState(initialFilters);
  const [filterStr, setFilterStr] = useState("");
  const [previewCart, setPreviewCart] = useState(null);

  const {
    isLoading,
    error,
    data: { totals = 0, total_amount = 0, data = [] } = {},
    refetch,
  } = useQuery({
    queryKey: ["lost_carts", { page, perPage, filterStr }],
    queryFn: fetchLostCarts,
  });

  const { data: { data: comment_states } = [] } = useQuery({
    queryKey: ["comment_states"],
    queryFn: getCommentStateOption,
  });

  useEffect(() => {
    dispatch(setOrderShopsOptions());
  }, []);

  const { onChangeChecked, checkedIncluded, checkedAll, setChecked, checked } =
    useChecked([]);

  const mutationFinishOrder = useMutation({
    mutationFn: (record_id) =>
      Axios({
        url: `/api/v1/lost_carts/${record_id}/finish_order`,
        method: "POST",
      }).then((res) => res.data),
    onSuccess: () => {
      refetch();
      antdMessageSuccess();
      setPreviewCart(null);
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const mutationDelete = useMutation({
    mutationFn: (record_id) =>
      Axios({
        url: `/api/v1/lost_carts/${record_id}`,
        method: "DELETE",
      }).then((res) => res.data),
    onSuccess: () => {
      refetch();
      antdMessageSuccess();
      setPreviewCart(null);
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  // console.log({ commentStates, filters });
  return (
    <Container
      location={{
        locationName: "Lost cart",
        locationUrl: match.url,
      }}
    >
      <ContentBlock>
        <FilterMenu
          iconComponent={<IconLostCart />}
          totals={totals}
          length={data?.length}
          text2="Lost cart"
          countPage={perPage}
          onChangeCountPage={setPerPage}
          customText={
            !!total_amount && (
              <div>
                <span className="filterMenuText first">Total:</span>
                <span className="firstLength">
                  <span>{returnEuroString(total_amount)}</span>
                </span>
              </div>
            )
          }
        />
      </ContentBlock>
      <ContentBlock containerClass={"py-1"}>
        <TableFilterBox
          filter={true}
          onFilter={() => {
            if (
              generateParams(filters, comment_states) == filterStr &&
              page == 1
            ) {
              return refetch();
            }
            setFilterStr(generateParams(filters, comment_states));
            setPage(1);
          }}
          add={false}
          clearFilter={() => setFilters(defaultFilters)}
          button1={
            <Dropdown
              arrow={true}
              trigger="click"
              menu={{
                items: [
                  {
                    key: "1",
                    label: (
                      <div
                        onClick={() => {
                          if (!checked.length)
                            return antdMessageError("Not selected");
                          AntdConfirm({
                            onOk: () =>
                              exportDocument(
                                `/api/v1/lost_carts/download_xlsx`,
                                `lost_carts_by_ids.xlsx`,
                                "POST",
                                {
                                  file_name: `lost_carts_by_ids.xlsx`,
                                  ids: checked,
                                }
                              ),
                          });
                        }}
                      >
                        Export selected
                      </div>
                    ),
                  },
                  {
                    key: "2",
                    label: (
                      <div
                        onClick={() =>
                          AntdConfirm({
                            onOk: () =>
                              exportDocument(
                                `/api/v1/lost_carts/download_xlsx?${filterStr}`,
                                `lost_carts_by_filters.xlsx`,
                                "POST",
                                {
                                  file_name: `lost_carts_by_filters.xlsx`,
                                }
                              ),
                          })
                        }
                      >
                        Export filtered
                      </div>
                    ),
                  },
                ],
              }}
              placement="bottomRight"
            >
              <button
                className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
                type="button"
              >
                Export
              </button>
            </Dropdown>
          }
        >
          {defaultFilters.map((filter) => (
            <div key={`filter_value_${filter.value}`} className=" px-1">
              {filter?.type == "date" ? (
                <RangePicker
                  style={{ width: 250 }}
                  label={filter.label}
                  value={
                    filters[filter.value]
                      ? [
                          getDateFormat(filters[filter.value][0]),
                          getDateFormat(filters[filter.value][1]),
                        ]
                      : []
                  }
                  onChange={(_, args) => {
                    setFilters((prev) => ({
                      ...prev,
                      [filter.value]: args,
                    }));
                  }}
                />
              ) : filter.label == "Comment statuses" ? (
                <div>
                  <Label className="text-sm-label">{filter.label}</Label>
                  <Select
                    placeholder={filter.label}
                    mode="multiple"
                    dropdownMatchSelectWidth={false}
                    value={filters[filter.value] || undefined}
                    style={{ width: 165 }}
                    onChange={(arg) =>
                      setFilters((prev) => ({
                        ...prev,
                        [filter.value]: arg,
                      }))
                    }
                    filterOption={(input, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    <OptGroup label={"KA comments"}>
                      {(comment_states || [])
                        .filter(
                          ({ comment_type }) => comment_type == "comment_ka"
                        )
                        .map((comment_state) => (
                          <Option
                            key={comment_state.id}
                            value={comment_state.id}
                          >
                            {comment_state.name}
                          </Option>
                        ))}
                    </OptGroup>
                    <OptGroup label={"Manager comments"}>
                      {(comment_states || [])
                        .filter(
                          ({ comment_type }) =>
                            comment_type == "comment_management"
                        )
                        .map((comment_state) => (
                          <Option
                            key={comment_state.id}
                            value={comment_state.id}
                          >
                            {comment_state.name}
                          </Option>
                        ))}
                    </OptGroup>
                  </Select>
                </div>
              ) : filter.value == "order_shop_id_in" ? (
                <div>
                  <SelectInput
                    label={filter.label}
                    mode="multiple"
                    style={{ width: 165 }}
                    dropdownMatchSelectWidth={false}
                    value={filters[filter.value] || undefined}
                    options={order_shops || []}
                    onChange={(value) => {
                      setFilters((prev) => ({
                        ...prev,
                        [filter.value]: value,
                      }));
                    }}
                  />
                </div>
              ) : (
                <TextInput
                  text={filter.label}
                  name={filter.value}
                  style={{ width: 165 }}
                  value={filters[filter.value] || ""}
                  onKeyDown={handleKeyDown2(() => {
                    if (
                      generateParams(filters, comment_states) == filterStr &&
                      page == 1
                    ) {
                      return refetch();
                    }
                    setFilterStr(generateParams(filters, comment_states));
                    setPage(1);
                  })}
                  onChange={(val) => {
                    const value = val.target.value;
                    setFilters((prev) => ({
                      ...prev,
                      [filter.value]: value,
                    }));
                  }}
                />
              )}
            </div>
          ))}
        </TableFilterBox>
        <ContentValidation loader={isLoading} array={data}>
          <TableUi
            ths={[
              <Checkbox
                checked={checkedAll(data.map(({ id }) => id))}
                onChange={() =>
                  setChecked(
                    checkedAll(data.map(({ id }) => id))
                      ? []
                      : data.map(({ id }) => id)
                  )
                }
              />,
              "Cart ID",
              "Store",
              "Lost date",
              "Client",
              "Goods",
              "Residues",
              "KA comments",
              "Manager comments",
              "",
            ]}
          >
            {data.map((record) => {
              return (
                <LostCartItem
                  key={record.id}
                  record={record}
                  checkedIncluded={checkedIncluded(record.id)}
                  onChangeChecked={() => onChangeChecked(record.id)}
                  openPreview={() => setPreviewCart(record.id)}
                  mutationFinishOrder={mutationFinishOrder}
                  mutationDelete={mutationDelete}
                />
              );
            })}
          </TableUi>
        </ContentValidation>
        <div className="mt-4">
          <Pagination
            page={page}
            setPagination={setPage}
            totals={totals}
            pageCount={DEFAULT_PER_PAGE}
          />
        </div>
      </ContentBlock>
      {typeof previewCart == "number" && (
        <ModalLostCart
          lost_cart_id={previewCart}
          close={() => {
            refetch();
            setPreviewCart(null);
          }}
          comment_states={comment_states}
          mutationFinishOrder={mutationFinishOrder}
          mutationDelete={mutationDelete}
        />
      )}
    </Container>
  );
}

const LostCartItem = ({
  checkedIncluded,
  onChangeChecked,
  record,
  openPreview,
  mutationFinishOrder,
  mutationDelete,
}) => {
  const commentMemo = useMemo(() => {
    const commentItems = record.comments.sort(
      (a, b) => new Date(b.created_at) + new Date(a.created_at)
    );
    return (
      <>
        <TableComment comments={commentItems} type="comment_ka" />
        <TableComment comments={commentItems} type="comment_management" />
      </>
    );
  }, [record.comments.length]);

  const productBalances = useMemo(() => {
    return record.order_rows
      .filter(
        (order_row) =>
          order_row.product_info &&
          Array.isArray(order_row.product_info?.product_suppliers)
      )
      .map((item) => (
        <BalancesIndex
          key={`balance_index_${item.id}`}
          item={item}
          disabled={false}
        />
      ));
  }, [record.order_rows]);

  return (
    <TableUi.tr className={"align-middle tableColumn"}>
      <TableUi.td className={"p-left"}>
        <Checkbox checked={checkedIncluded} onChange={onChangeChecked} />
      </TableUi.td>
      <TableUi.td>
        <div className="cursor-pointer" onClick={openPreview}>
          {record.cart_id}
        </div>
      </TableUi.td>
      <TableUi.td>{record.shop?.title || "-"}</TableUi.td>
      <TableUi.td>
        <span className="date-field">
          {moment(record.lost_at).format("YYYY MM DD")}
        </span>
        <br />
        <span className="date-field">
          {moment(record.lost_at).format("HH:mm")}
        </span>
      </TableUi.td>
      <TableUi.td>
        <ClientInfoComponent
          client={record.customer}
          customer={record.customer}
          shipping_address={record.shipping_address}
        />
      </TableUi.td>
      <TableUi.td>
        <table className="table-hover table-sm">
          <tbody style={{ fontWeight: "400" }}>
            {record.order_rows.map((order_row, idx) => (
              <tr key={`order_row_${order_row.id}`}>
                <td>
                  <div
                    style={{
                      borderLeft: "2px solid #D9D9D9",
                      marginTop: idx > 0 ? 10 : 0,
                      paddingLeft: 6,
                    }}
                  >
                    {order_row.product_name}
                  </div>
                </td>
                <td>{parseInt(order_row.quantity)}</td>
                <td>
                  <div
                    className="text-right"
                    style={{
                      width: 60,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {returnEuroString(order_row.unit_price_tax_incl)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableUi.td>
      <TableUi.td>
        <table className="table-hover table-sm">
          <tbody style={{ fontWeight: "400" }}>{productBalances}</tbody>
        </table>
      </TableUi.td>
      {commentMemo}
      <TableUi.td>
        <div className="d-flex justify-content-end align-items-center">
          <>
            <Tooltip placement="top" title="Finish order">
              <div>
                <ButtonSmall
                  disabled={mutationFinishOrder.isLoading}
                  className={"mr-2"}
                  onClick={() =>
                    AntdConfirm({
                      onOk: () => {
                        mutationFinishOrder.mutate(record.id);
                      },
                    })
                  }
                >
                  <AiOutlineCheck color={"#fff"} />
                </ButtonSmall>
              </div>
            </Tooltip>
          </>
          <>
            <Tooltip placement="top" title="Forget">
              <div>
                <ButtonDelete
                  disabled={mutationDelete.isLoading}
                  onDelete={() =>
                    AntdConfirm({
                      onOk: () => {
                        mutationDelete.mutate(record.id);
                      },
                    })
                  }
                />
              </div>
            </Tooltip>
          </>
        </div>
      </TableUi.td>
    </TableUi.tr>
  );
};

const LostCartScreenWrapper = ({ match }) => {
  return (
    <QueryClientProvider client={queryLostCartsClient}>
      <LostCartScreen match={match} />
    </QueryClientProvider>
  );
};

export default LostCartScreenWrapper;

const generateParams = (filters = {}, comment_states = []) => {
  let filtStr = Object.entries(filters)
    .filter(([key, value]) => {
      if (!value) return false;

      if (key === "lost_at") {
        const [startDate, endDate] = value;
        const filters = [];

        if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
        if (endDate) filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

        return filters.length > 0;
      }

      if (typeof value === "string") {
        value = value.trim();
        return value.length > 0;
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return typeof value === "string";
    })
    .map(([key, value]) => {
      if (key === "lost_at") {
        const [startDate, endDate] = value;
        const filters = [];

        if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
        if (endDate) filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

        return filters.join("&");
      }
      if (key == "comment_states") {
        console.log({ key, value });
        const filters = [];
        value.forEach((item) => {
          const comment_state = comment_states.find((s) => s.id == item);
          if (comment_state) {
            filters.push(`q[${comment_state.comment_type}_id_in][]=${item}`);
          }
        });
        return filters.join("&");
      }

      if (key.includes("_in")) {
        const filters = [];
        value.forEach((item) => {
          filters.push(`q[${key}][]=${item}`);
        });
        return filters.join("&");
      }

      return `q[${key}]=${value}`;
    })
    .join("&");
  if (filtStr !== "") {
    filtStr = "&" + filtStr;
  }
  return filtStr;
};
